import { CenterItem, Column } from '@components/LinearLayout';
import {
  SectionRoot,
  Subtitle,
  SubtitleWrapper,
  Title,
  TitleWrapper,
  Underline,
  UnderlineContainer,
} from './styles';

import Button from '@components/Button';
import { getEventDetails } from '@store/slices/eventSlice';
import { useMobileWidth } from '@utils/hooks';
import { useSelector } from 'react-redux';
import { useTheme } from 'styled-components';
import FadeInOnScroll from '@components/Transitions/FadeInScroll';

interface TextButtonProps {
  title: string;
  subtitle?: string;
  button?: React.ReactNode;
  buttonText?: string;
  hideButton?: boolean;
  padding?: string;
  maxWidth?: string;
  gap?: string;
  buttonOnClick?: (...args: never[]) => void;
}

const TextButton = ({
  title,
  subtitle,
  button,
  buttonText = '',
  hideButton = false,
  gap,
  padding,
  maxWidth,
  buttonOnClick,
}: TextButtonProps) => {
  const theme = useTheme();
  const isMobile = useMobileWidth();
  const sluggedEvent = useSelector(getEventDetails)?.[0];

  return (
    <SectionRoot padding={padding} maxWidth={maxWidth}>
      <FadeInOnScroll>
        <Column $gap={gap || '2rem'}>
          <TitleWrapper>
            <Title>{title}</Title>
            <UnderlineContainer>
              <Underline color={sluggedEvent?.design?.themeColor} />
            </UnderlineContainer>
          </TitleWrapper>

          <SubtitleWrapper>
            <Subtitle>{subtitle}</Subtitle>
          </SubtitleWrapper>
        </Column>
      </FadeInOnScroll>
      <Column>
        <CenterItem>
          {!hideButton &&
            (button || (
              <Button
                title={buttonText}
                backgroundColor={sluggedEvent?.design?.themeColor}
                hoverBackgroundColor={theme.color.mobilityGrey}
                textColor={theme.color.white}
                borderRadius={theme.borderRadius.radius10}
                fontSize={theme.fontSize.size20}
                lineHeight={theme.lineHeight.height150}
                padding={isMobile ? '1.5rem 2.5rem' : '1.1rem 4.9rem'}
                width={isMobile ? '100%' : 'max-context'}
                onClick={buttonOnClick}
              />
            ))}
        </CenterItem>
      </Column>
    </SectionRoot>
  );
};

export default TextButton;
